const definitions = {
  defaultPageSize: 10,
}

export default definitions
